import { api } from '../../services/apiClient';

export interface Plan {
  membership_id: number;
  kydemy_id: number | null;
  name: string;
  code: string | null;
  color: string | null;
  price_month: string | null;
  price_trimester: string | null;
  price_year: string | null;
  classes_month: number | null;
  position: number | null;
  default_discount_id: number | null;
  default_discount_name: string | null;
  default_discount_value: string | null;
  default_discount_is_percentage: number | null;
  deleted: number;
  student_count: number;
}

export function listPlans(all = false) {
  return api.get<{ data: Plan[] }>(`/memberships${all ? '?all=1' : ''}`);
}

export interface PlanInput {
  name: string;
  code?: string | null;
  color?: string | null;
  price_month?: number | null;
  price_trimester?: number | null;
  price_year?: number | null;
  classes_month?: number | null;
  default_discount_id?: number | null;
}

export function createPlan(p: PlanInput) {
  return api.post<{ ok: true; membership_id: number }>(`/memberships`, p);
}
export function updatePlan(id: number, patch: Partial<PlanInput> & { deleted?: number }) {
  return api.put<{ ok: true }>(`/memberships/${id}`, patch);
}
export function archivePlan(id: number) {
  return api.del<{ ok: true }>(`/memberships/${id}`);
}

export function money(n: number | string | null) {
  return '$' + Number(n || 0).toLocaleString('es-MX', { maximumFractionDigits: 0 });
}

// ── Descuentos ──
export interface Discount {
  discount_id: number;
  kydemy_id: number | null;
  name: string;
  code: string | null;
  value: string | null;
  is_percentage: number;
  membership_id: number | null;
  membership_name: string | null;
  duration_months: number | null;
  deleted_at: string | null;
  student_count: number;
}
export function listDiscounts(all = false) {
  return api.get<{ data: Discount[] }>(`/discounts${all ? '?all=1' : ''}`);
}
export interface DiscountInput {
  name: string; code?: string | null; value: number; is_percentage: number;
  membership_id?: number | null; duration_months?: number | null;
}
export function createDiscount(d: DiscountInput) {
  return api.post<{ ok: true; discount_id: number }>(`/discounts`, d);
}
export function updateDiscount(id: number, patch: Partial<DiscountInput> & { restore?: boolean }) {
  return api.put<{ ok: true }>(`/discounts/${id}`, patch);
}
export function archiveDiscount(id: number) {
  return api.del<{ ok: true }>(`/discounts/${id}`);
}
/** "−$100" o "−20%" */
export function discountLabel(value: string | number | null, isPct: number | boolean): string {
  const v = Number(value || 0);
  if (!v) return '';
  return isPct ? `−${v}%` : `−$${v.toLocaleString('es-MX')}`;
}
